import React, { useState } from 'react';
import {
  Button,
  IconButton,
  FormControl,
  Typography,
  Box,
  Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileUploadIcon from "@mui/icons-material/FileUpload";

/* 
DESCRIPTION
This Component accepts one function as prop which 
sends images selected by user to parent Component

IMAGE FORMAT
{
    name: "",
    base64_data: "",
    mime_type: ""
}

FEATURES
1) Doesn't allow more than 1 MB
2) Allows Multiple Images
3) Only JPG, JPEG, PNG are allowed 
           
EXISTING ISSUES
1) ErrorMessage might not show correctly
2) Each Image takes 100% width of the container

Happy Coding, Cheers! 
Meghnadh
*/
           
const ImageUploader = ({showUploadButton, previouslyUploadedImages, sendImageDataToParent}) => {
  let initialImages = []
  if ( previouslyUploadedImages?.length != 0) {
    initialImages = previouslyUploadedImages;
  }
  const [images, setImages] = useState(initialImages);
  const [errorMessage, setErrorMessage] = useState('');

  const handleImageUpload = (e) => {
    const selectedFiles = Array.from(e.target.files);

    // Validate file types and size
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const maxSize = 1024 * 1024; // 1MB
    let errorMessages=[]
    const validatedFiles = selectedFiles.filter((file) => {
      if (!allowedTypes.includes(file.type)) {
        errorMessages.push('Only JPG, JPEG, or PNG images are allowed.');
        return false;
      }
      if (file.size > maxSize) {
        errorMessages.push('File size exceeds 1MB limit.');
        return false;
      }
      return true;
    });

    // Reset error message
    if(errorMessages?.length > 0){
      setErrorMessage(errorMessages[0]);
      return true
    }
    setErrorMessage('');

    // Read and encode selected files as base64
    const newImages = [...images];
    validatedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const dataUrl = e.target.result;
        newImages.push({
            name: file?.name,
            base64_data: dataUrl,
            mime_type: file?.type,
            url : dataUrl //For passing into src attr of image tag 
        })
        //{ dataUrl, file });
        setImages(newImages);
        const payloadForImages = newImages?.map( image => {
          const {name, base64_data, mime_type} = image;
          return {name, base64_data, mime_type};
        })
        sendImageDataToParent(payloadForImages);
      };
      reader.readAsDataURL(file);
    });
    
  };

  const handleRemoveImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
    sendImageDataToParent(newImages);
  };

  return (
    <div>
        {showUploadButton &&
          <FormControl sx={{
                m: 1,
                display:  "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed lightgray",
                height: "120px",
                width: '100%'
              }}
          >
            <label htmlFor="image-upload-input">
                <input
                    type="file"
                    accept="image/jpeg, image/jpg, image/png"
                    onChange={handleImageUpload}
                    multiple
                    style={{ display: 'none' }}
                    id="image-upload-input"
                />
      
                  <Button
                      sx={{ textTransform: 'capitalize !important' }}
                      color="secondary"
                      style={{ backgroundColor: "white", color: "grey", display: "flex", flexDirection: "column" }}
                      variant="contained"
                      component="span"
                  >
                      <FileUploadIcon />
                      Click to Upload
                  </Button>
            </label>
            
            {errorMessage && (
                <Typography variant="body2" color="error">
                {errorMessage}
                </Typography>
            )}
          </FormControl>
        }
      <Grid container spacing={2} style={{width:'100%',margin:"8px"}}>
        {images?.map((image, index) => (
          <Grid item key={index} style={{
            padding: "8px",
            display: "flex",
            justifyContent: "center",
            width: "100%",
            border: "2px dashed lightgray",
            alignItems: "center",
            // margin: "1.5rem",
          }} >
            <Box position="relative" >
              <div style={{display:'flex',justifyContent:'center'}}>
                <img
                  src={image.url || image?.base64_data || image}
                  alt={`Img ${index + 1}`}
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </div>
              <IconButton
                size="small"
                color="white"
                onClick={() => handleRemoveImage(index)}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: "100%",
                  background: 'red',
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default ImageUploader;
